<template>
  <div
    class="marquee-container"
    @mouseleave="play"
    @mouseenter="pause"
    :style="{ opacity: this.hide && !this.instant ? 0 : 1 }"
  >
    <a
      href="https://shop.dublab.com/products/dublab-donation"
      class="donateLink"
      :style="{ display: this.isOverflow && this.isHeader ? 'none' : 'inline' }"
    >
      <button :class="['button pill solid donatepill']">Donate</button>
    </a>
    <flickity
      class="marquee"
      ref="flickity"
      v-if="items"
      v-on:init="flickityInit"
      :options="flickityOptions"
      :style="{ width: (this.isOverflow && this.isHeader) && '100%'}"
    >
      <div class="marquee-item" v-for="(item, i) in items" :key="i">
        <vue-link v-if="item.url" :to="item.url" v-html="item.text"></vue-link
        ><span v-else v-html="item.text"></span><span class="spacer">•</span>
      </div>
    </flickity>
  </div>
</template>

<script>
import Flickity from "vue-flickity";
import VueLink from "./VueLink.js";

export default {
  name: "Marquee",
  components: { Flickity, VueLink },
  props: {
    items: Array,
    autoplay: Boolean,
    instant: Boolean,
    isHeader: {
      type: Boolean,
      default: false
    },
    isOverflow: Boolean
  },
  data() {
    return {
      playing: false,
      raf: null,
      x: 0,
      flickityOptions: {
        freeScroll: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        cellAlign: "left",
      },
      fixTick: null,
      autoplayTick: null,
      hide: true,
    };
  },
  methods: {
    flickityInit() {
      this.$refs.flickity.on("dragStart", () => {
        this.$refs.flickity.$el.style.pointerEvents = "none";
      });
      this.$refs.flickity.on("dragEnd", () => {
        this.$refs.flickity.$el.style.pointerEvents = "auto";
      });

      this.$refs.flickity.$flickity.x = 0;

      this.fixTick = setTimeout(() => {
        this.$refs.flickity.resize();
        this.hide = false;
      }, 500);

      if (this.autoplay) {
        this.autoplayTick = setTimeout(() => {
          this.play();
        }, 1000);
      }
    },
    play() {
      if (!this.playing) {
        this.playing = true;
        this.frame();
      }
    },
    frame() {
      this.$refs.flickity.$flickity.x = this.$refs.flickity.$flickity.x - 0.5;
      this.$refs.flickity.$flickity.positionSlider();
      this.raf = window.requestAnimationFrame(this.frame);
    },
    pause() {
      window.cancelAnimationFrame(this.raf);
      this.raf = undefined;
      this.playing = false;
    },
  },
  beforeDestroy() {
    this.pause();
    clearTimeout(this.fixTick);
    clearTimeout(this.autoplayTick);
  },
};
</script>

<style scoped>
.marquee-container {
  overflow: hidden;
  padding-bottom: 1rem;
}

.marquee {
  white-space: nowrap;
  width: calc(100% - 2rem - 140px);
  float: right;
}

.marquee-item {
  display: inline-block;
  padding: 1rem 0 1rem 1rem;
  transform: translateZ(0);
}

.spacer {
  padding-left: 1rem;
}

@media screen and (max-width: 700px) {
  .marquee {
    width: calc(100% - 1rem);
  }
}
</style>
